<template>
	<div style="width:100%;height:100%;" ref="pie">

	</div>
</template>

<script>
	import echarts from 'echarts'

	function setOption(data) {
		var option = {
			backgroundColor: '#fff',
			// title: {
			// 	text:data.title.allNum,
			// 	subtext: data.title.name,
			// 	left: '37%',
			// 	top: '50%'
			// },
			grid:{
				left: '0%', //grid 组件离容器左侧的距离。
				right: '6%', //grid 组件离容器右侧的距离。
				top:'0%',
				bottom: '4%', //grid 组件离容器下侧的距离。
				containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
			},
			tooltip: {
				show: true,
				trigger: 'item',
				formatter: "{b}: {c} ({d}%)"
			},
			legend: {
				type: 'scroll',
				// orient: 'horizontal',
				orient: 'vertical',
				left: '68%',
				top: 'middle',
				itemGap: 5,
				itemWidth: 4,
				itemHeight: 12,
				padding: 12,
				// bottom: '0%',
				data: data.legend
			},
			series: [{
	            type:'pie',
	            selectedMode: 'false',
				silent: true,
	            radius: ['55%', '88%'],
				center : ['40%','50%'],
	            //color:['#CCCCCC'],
	            label: {
	                normal: {
	                    position: 'center',
	                    formatter: '{c}',
	                    textStyle: {
							color: '#30B1D3',
							fontSize: 18,
							fontWeight:'bold'
						},
	                }
	            },
	            itemStyle:{
					normal:{
								color:'rgba(0,0,0,0.05)'
							},
	            },
	            data:[
	                {value:data.total}
	            ]
	        },{
				type: 'pie',
				selectedMode: 'false',
				radius: ['52%', '80%'],
				center : ['40%','50%'],
				color: ['#ec604d','#f6a852', '#F8D770', '#95e995', '#C5C5C5','#F8AE71'],
				label: {
					normal: {
						position: 'inner',
						// formatter: '{d}%',
						formatter: function(params){
							if(params.value == 0){
								return "";
							}
							return params.value;
						},
						textStyle: {
							color: '#57617B',
							fontSize: 12
						}
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
				data: data.data
			}]
		};
		return option
	}
	export default {
		name: 'CsPie',
		props: ['args'],
		methods: {
			initChart() {
				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
			reDrawChart: function(args) {
				
				this.myChart.setOption(setOption(args), false);
			}
		},
		mounted: function(el) {
			var container = this.$el;
			this.initChart();
			this.myChart = echarts.init(container);
			let _this = this;
			this.myChart.on('click',function(param){
				_this.$emit('pieClick',param.data.name);
			});
		},
		watch: {
			updateFlag: function(val) {
				setTimeout(() => {
					this.myChart.resize()
				}, 150);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/pieChart.vue